<template>
    <el-form :model="vo" @submit.native.prevent>
    <div style="width:100%;" class="el-table el-table--fit  ">
    <div class="el-table__body-wrapper">
    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
      <tbody>
      	<tr>
      		<td ref="tdlbl_调离类型" class="el-table__cell tdlbl tdw13" colspan="1">

                <span v-field-lbl="'transferType'" class="field">调离类型</span>
            </td>
      		<td class="el-table__cell tdcont tdw20" colspan="1">
      				<form-item ref="transferType" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：辞职\n2：退休\n3：辞退','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择调离类型','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'调离类型','propName':'transferType','propType':'Short','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.transferType','option':[{'value':'1','name':'辞职'},{'value':'2','name':'退休'},{'value':'3','name':'辞退'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />
            </td>
      		<td ref="tdlbl_辞职/辞退/退休时间" class="el-table__cell tdlbl tdw13" colspan="1">

                <span v-field-lbl="'transferDate'" class="field">辞职/辞退/退休时间</span>
            </td>
      		<td class="el-table__cell tdcont tdw20" colspan="1">
      				<form-item ref="transferDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'请选择','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'辞职/辞退/退休时间','propName':'transferDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'transferdate','iconName':'sjxzk','model':'vo.transferDate','option':[],'formTdAlign':'text-left','weekday':0}" :vo="vo" :can-edit="canEdit" />
            </td>
      		<td ref="tdlbl_预计退休时间" class="el-table__cell tdlbl tdw13" colspan="1">

                <span v-field-lbl="'planTransferDate'" class="field">预计退休时间</span>
            </td>
      		<td class="el-table__cell tdcont tdw20" colspan="1">
      				<form-item ref="planTransferDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'请选择','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'预计退休时间','propName':'planTransferDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'plantransferdate','iconName':'sjxzk','model':'vo.planTransferDate','option':[],'formTdAlign':'text-left','weekday':0}" :vo="vo" :can-edit="canEdit" />
            </td>
      	</tr>
      </tbody>
    </table>
    </div>
    </div>
    </el-form>
</template>
<script>
export default {
 	props: {
 	    vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 },
        moduleInfo: { type: Object, default: function() { return {} } }
    },
    data: function() {
        return {
        	loginUser: this.$store.getters.loginUser
        }
    },
    computed: {
    },
    created: function() {
    }

}

</script>

<style>
</style>
